import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface ModalShellProps {
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}

export const ModalShell = ({ title, onClose, children, footer }: ModalShellProps) =>
  createPortal(
    <div
      role='dialog'
      aria-modal='true'
      className='fixed inset-0 z-50 flex items-center justify-center bg-black/40'
      onClick={onClose}
    >
      <div className='mx-4 w-full max-w-md rounded-lg bg-white shadow-xl' onClick={(e) => e.stopPropagation()}>
        <div className='border-b border-neutral-200 px-6 py-4'>
          <h3 className='text-lg font-medium text-neutral-900'>{title}</h3>
        </div>

        <div className='px-6 py-4 text-sm text-neutral-700'>{children}</div>

        <div className='flex justify-end gap-2 border-t border-neutral-200 px-6 py-3'>
          {footer ?? (
            <button
              type='button'
              onClick={onClose}
              className='rounded-md bg-neutral-900 px-4 py-1.5 text-sm font-medium text-white hover:bg-neutral-800'
            >
              Got it
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
